const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { randomId } = require('@bluekiri/alexandria/helpers/dataHelpers');
const prototype = require('./prototype');
const InputClient = require('../../../input/client/js/index');

/**
 * Autocomplete component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function Autocomplete(selector = '[data-component="Autocomplete"]', configuration = {}) {
    if (elementExist(selector)) {
        const instance = Object.create(prototype);

        instance.element = document.querySelector(selector);
        instance.id = instance.element.dataset.id || randomId('autocomplete');
        instance.error = false;
        instance.config = { ...instance.getConfig(), ...configuration };

        instance.input = InputClient(`${selector} [data-component="Input"]`);

        if (instance.config.init) {
            instance.initialize();
        }

        return instance;
    }
};
